<template>
  <div class="">
    <!-- Dialog -->
    <Dialog :title="$t(`Let's add a changelog entry`)" v-model="dialogOpen">
      <form @submit.prevent="editDraft">
        <div class="px-4 pt-4 pb-4 sm:px-6 sm:pb-4">
          <p class="text-neutral-600">{{ $t('FeedBear can generate a changelog draft for "{title}"', { title: this.post.title }) }}</p>
          <transition name="fade" v-if="isLoading">
            <div class="flex flex-row justify-center rounded-sm bg-gray-100 mt-4">
              <Spinner class="ml-3" border-color="#6b7280" />
              <div class="m-2 mt-4 text-sm mb-4 text-neutral-600">{{ $t('Generating changelog entry with AI...') }}</div>
            </div>
          </transition>
          <transition name="fade" v-if="!isLoading && this.changelogTitle">
            <div class="flex flex-col justify-center rounded-lg mt-6 bg-black bg-opacity-5">
              <p class="text-neutral-700 font-bold p-4">{{this.changelogTitle}}</p>
              <div v-html="this.changelogBody" class="text-neutral-600 text-sm border-t border-neutral-300 p-4" style="overflow-y: auto; max-height: 200px;"></div>
            </div>
          </transition>
          <transition name="fade" v-if="!isLoading && isError">
            <div class="alert alert--bad rounded-lg mt-6">
              <p class="ml-2 mr-2">{{ $t('There was an error generating the text.') }} <a href="#" class="text-white underline" @click.prevent="getSuggestion()">{{ $t('Please try again...') }}</a></p>
            </div>
          </transition>
        </div>
        <div class="px-4 py-3 sm:px-6 flex items-center justify-between">
          <a href="/edit?view=ai_settings" class="text-sm text-neutral-700">
            {{ $t('Edit AI Settings') }}
          </a>
          <button type="submit" class="inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 text-sm font-medium text-white" style="background-color: var(--accent-color)">
            {{ $t('Edit draft') }}
          </button>
        </div>
      </form>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "./dialog";
import Spinner from "../projects/spinner";

export default {
  props: ["post", "company-details", "show-changelog-post-suggestion"],
  data() {
    return {
      dialogOpen: true,
      changelogTitle: "",
      changelogBody: "",
      isLoading: false,
      isError: false,
    };
  },
  components: {
    Dialog,
    Spinner,
  },
  computed:{
  },
  watch: {
    dialogOpen(open) {
      if (!open) this.$emit("dismissed");
    }
  },
  mounted() {
    this.isLoading = true;
    this.isError = false;
    let data = new FormData();
    data.append("post_id", this.post.id);
    Rails.ajax({
      url: `/changelog/suggest_entry`,
      type: "POST",
      data: data,
      dataType: "json",
      beforeSend: function () {
        return true;
      },
      success: (data) => {
        this.isLoading = false;
        this.changelogTitle = data.changelog_suggested_title;
        this.changelogBody = data.changelog_suggested_body;
      },
      error: (data, status) => {
        this.isLoading = false;
        this.isError = true;
        console.log(data);
      },
    });
  },
  methods: {
    getSuggestion() {
      this.isLoading = true;
      this.isError = false;
      let data = new FormData();
      data.append("post_id", this.post.id);
      Rails.ajax({
        url: `/changelog/suggest_entry`,
        type: "POST",
        data: data,
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          this.isLoading = false;
          this.changelogTitle = data.changelog_suggested_title;
          this.changelogBody = data.changelog_suggested_body;
        },
        error: (data, status) => {
          this.isLoading = false;
          this.isError = true;
          console.log(data);
        },
      });
    },
    editDraft() {
      let data = new FormData();
      data.append("changelog_entry[title]", this.changelogTitle);
      data.append("changelog_entry[body]", this.changelogBody);
      Rails.ajax({
        url: '/changelog/suggestion/create',
        type: "POST",
        data: data,
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          window.location.href = `/updates/${data.id}/edit`;
        },
        error: (data, status) => {
          console.log(data);
        },
      });
    },
    disableChangelogSuggestions() {
      const data = {post_id: this.postId}
      Rails.ajax({
        url: "/changelog/suggestion/disable",
        type: "POST",
        data: data,
        dataType: "json",
        beforeSend: function () {
        },
        success: (data) => {
          this.show = false;
        },
        error: (data, status) => {
          console.log(data);
        },
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.iconColor:hover svg{
  fill: white;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
